import React from 'react'
import './Hero.css'
import dark_arrow from '../../assets/dark-arrow.png'
const Hero = () => {
  return (
    <div className='hero container'>
        <div className="hero-text">
           <h1>Together, we can make a difference.</h1> 
            <p>Empowering Communities, Inspiring Change: Together, We Create Hope for a Brighter Tomorrow</p>
            
            <button className='btn'>Explore More <img src={dark_arrow} alt=""/></button>
            </div>
    </div>
  )
}

export default Hero